
// import React, { useRef, useEffect } from 'react';
// import { User, Mail, Phone, MapPin, Settings, LogOut, Edit } from 'lucide-react';

// function Profile({ user, isOpen, onClose, onLogout }) {
//   const dropdownRef = useRef(null);

//   // Close dropdown when clicking outside
//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         onClose();
//       }
//     }

//     if (isOpen) {
//       document.addEventListener('mousedown', handleClickOutside);
//     }

//     return () => {
//       document.removeEventListener('mousedown', handleClickOutside);
//     };
//   }, [isOpen, onClose]);

//   if (!isOpen) return null;

//   const handleLogout = () => {
//     onLogout();
//     onClose();
//   };

//   return (
//     <div 
//       ref={dropdownRef}
//       className="absolute top-10 right-0 w-80 bg-white rounded-xl shadow-lg z-50 overflow-hidden"
//     >
//       {/* Header Section */}
//       <div className="bg-gradient-to-r from-rose-500 to-rose-600 p-4">
//         <div className="flex items-center gap-3">
//           <div className="w-12 h-12 bg-white bg-opacity-20 rounded-full flex items-center justify-center text-white font-bold text-lg">
//             {user?.name?.charAt(0)?.toUpperCase() || 'U'}
//           </div>
//           <div className="flex-1">
//             <h2 className="text-white font-semibold text-lg">{user?.name || 'User Name'}</h2>
//           </div>
//         </div>
//       </div>

//       {/* User Info Section */}
//       <div className="p-4 border-b border-gray-100">
//         <div className="space-y-3">
//           <div className="flex items-center gap-3 text-sm">
//             <Mail className="w-4 h-4 text-gray-400" />
//             <span className="text-gray-700">{user.email}</span>
//           </div>
//           <div className="flex items-center gap-3 text-sm">
//             <Phone className="w-4 h-4 text-gray-400" />
//             <span className="text-gray-700">{user.phone}</span>
//           </div>
//         </div>
//       </div>

//       {/* Menu Items */}
//       <div className="py-2">
//         <button className="w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-gray-50 transition-colors duration-200">
//           <User className="w-4 h-4 text-gray-500" />
//           <span className="text-gray-700 font-medium">View Profile</span>
//         </button>

//         <button className="w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-gray-50 transition-colors duration-200">
//           <Edit className="w-4 h-4 text-gray-500" />
//           <span className="text-gray-700 font-medium">Edit Profile</span>
//         </button>

//         <button className="w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-gray-50 transition-colors duration-200">
//           <Settings className="w-4 h-4 text-gray-500" />
//           <span className="text-gray-700 font-medium">Account Settings</span>
//         </button>
//       </div>

//       {/* Logout Section */}
//       <div className="border-t border-gray-100 p-2">
//         <button 
//           onClick={handleLogout}
//           className="w-full flex items-center gap-3 px-4 py-3 text-left text-red-600 hover:bg-red-50 rounded-lg transition-colors duration-200"
//         >
//           <LogOut className="w-4 h-4" />
//           <span className="font-medium">Sign Out</span>
//         </button>
//       </div>
//     </div>
//   );
// }

// export default Profile;

import React, { useRef, useEffect } from "react";
import { User, Mail, Phone, LogOut, ShoppingBag } from "lucide-react";
import { Link } from "react-router-dom";

function Profile({ user, isOpen, onClose, onLogout }) {
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        onClose();
      }
    }
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const handleLogout = () => {
    onLogout();
    onClose();
  };

  return (
    <div
      ref={dropdownRef}
      className="absolute top-10 right-0 w-80 bg-white rounded-xl shadow-lg z-50 overflow-hidden"
    >
      {/* Header Section */}
      <div className="bg-gradient-to-r from-rose-500 to-rose-600 p-4">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 bg-white bg-opacity-20 rounded-full flex items-center justify-center text-white font-bold text-lg">
            {user?.name?.charAt(0)?.toUpperCase() || "U"}
          </div>
          <div className="flex-1">
            <h2 className="text-white font-semibold text-lg">
              {user?.name || "User Name"}
            </h2>
          </div>
        </div>
      </div>

      {/* User Info Section */}
      <div className="p-4 border-b border-gray-100">
        <div className="space-y-3">
          <div className="flex items-center gap-3 text-sm">
            <Mail className="w-4 h-4 text-gray-400" />
            <span className="text-gray-700">{user.email}</span>
          </div>
          <div className="flex items-center gap-3 text-sm">
            <Phone className="w-4 h-4 text-gray-400" />
            <span className="text-gray-700">{user.phone}</span>
          </div>
        </div>
      </div>

      {/* Menu Items */}
      <div className="py-2">
        <Link
          to="/profile"
          onClick={onClose}
          className="w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-gray-50 transition-colors duration-200"
        >
          <User className="w-4 h-4 text-gray-500" />
          <span className="text-gray-700 font-medium">Manage Profile</span>
        </Link>

        <Link
          to="/userorders"
          onClick={onClose}
          className="w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-gray-50 transition-colors duration-200"
        >
          <ShoppingBag className="w-4 h-4 text-gray-500" />
          <span className="text-gray-700 font-medium">Order History</span>
        </Link>

        {/* <button className="w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-gray-50 transition-colors duration-200">
          <Edit className="w-4 h-4 text-gray-500" />
          <span className="text-gray-700 font-medium">Edit Profile</span>
        </button>

        <button className="w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-gray-50 transition-colors duration-200">
          <Settings className="w-4 h-4 text-gray-500" />
          <span className="text-gray-700 font-medium">Account Settings</span>
        </button> */}
      </div>

      {/* Logout Section */}
      <div className="border-t border-gray-100 p-2">
        <button
          onClick={handleLogout}
          className="w-full flex items-center gap-3 px-4 py-3 text-left text-red-600 hover:bg-red-50 rounded-lg transition-colors duration-200"
        >
          <LogOut className="w-4 h-4" />
          <span className="font-medium">Sign Out</span>
        </button>
      </div>
    </div>
  );
};

export default Profile;